// Hostel Onboarding Form Field Constants

export const HOSTEL_TYPES = [
  { value: "hostel", label: "Hostel" },
  { value: "gurukul", label: "Gurukul" },
  { value: "boarding", label: "Boarding School" },
] as const;

export const HOSTEL_GENDER_TYPES = [
  { value: "boys", label: "Boys" },
  { value: "girls", label: "Girls" },
  { value: "co-ed", label: "Co-ed" },
] as const;

export const FACILITIES = [
  "Library",
  "WiFi",
  "RO Water",
  "Mess",
  "CCTV",
  "Study Hall",
  "Sports",
  "Medical Help",
  "Laundry",
  "Generator",
  "Air Conditioning",
  "Gymnasium",
  "Computer Lab",
  "Prayer Hall",
] as const;

export const ROOM_TYPES = ["Single", "Double", "Triple", "Dormitory"] as const;

export const FUNDING_TYPES = [
  { value: "donation", label: "Donation" },
  { value: "grant", label: "Grant" },
  { value: "loan", label: "Loan" },
  { value: "csr", label: "CSR" },
  { value: "government", label: "Government Funding" },
] as const;

export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
] as const;

export const HOSTEL_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

// Form step configuration
export const HOSTEL_ONBOARDING_STEPS = [
  {
    step: 1,
    title: "Basic Information",
    description: "Hostel name, type, and contact details",
  },
  {
    step: 2,
    title: "Address Information",
    description: "Complete address and location",
  },
  {
    step: 3,
    title: "Capacity & Facilities",
    description: "Room details and available facilities",
  },
  {
    step: 4,
    title: "Trustee Information",
    description: "Trustee and management details",
  },
  {
    step: 5,
    title: "Funding Information",
    description: "Funding requirements and support",
  },
] as const;

// Type exports for TypeScript
export type HostelType = (typeof HOSTEL_TYPES)[number]["value"];
export type HostelGenderType = (typeof HOSTEL_GENDER_TYPES)[number]["value"];
export type Facility = (typeof FACILITIES)[number];
export type RoomType = (typeof ROOM_TYPES)[number];
export type FundingType = (typeof FUNDING_TYPES)[number]["value"];
export type IndianState = (typeof INDIAN_STATES)[number];
export type HostelStatus = (typeof HOSTEL_STATUS)[keyof typeof HOSTEL_STATUS];
